<script setup lang="ts">
import { tv } from 'tailwind-variants';

const props = defineProps({
  isDisabledNext: {
    type: Boolean,
    default: false,
  },
  isDisabledPrevious: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(['next', 'previous']);

const { root, button } = tv({
  slots: {
    root: 'flex gap-2',
    button:
      'rounded-lg p-1 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed',
  },
  variants: {
    isDisabled: {
      true: {
        button: 'opacity-50 cursor-not-allowed',
      },
      false: {
        button: 'hover:bg-brand-black-alpha-5 active:bg-brand-black-alpha-7',
      },
    },
  },
})();

function onClickNext() {
  emit('next');
}

function onClickPrevious() {
  emit('previous');
}
</script>

<template>
  <div :class="root()">
    <button
      :disabled="props.isDisabledPrevious"
      :class="button({ isDisabled: props.isDisabledPrevious })"
      @click="onClickPrevious"
    >
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.78 5.47a.75.75 0 0 1 0 1.06L8.31 10l3.47 3.47a.75.75 0 1 1-1.06 1.06l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 0Z"
          fill="#4A4A4A"
        />
      </svg>
    </button>

    <button
      :disabled="props.isDisabledNext"
      :class="button({ isDisabled: props.isDisabledNext })"
      @click="onClickNext"
    >
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.72 14.53a.75.75 0 0 1 0-1.06L11.19 10 7.72 6.53a.75.75 0 0 1 1.06-1.06l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06 0Z"
          fill="#4A4A4A"
        />
      </svg>
    </button>
  </div>
</template>
